import React from "react";
import { t } from "../../../helpers/translator";

export default function failPopup() {
	return (
		<div className="ticket-results-view-p">
			<h3>{t("Something went wrong!")}</h3>
			<h3>{t(this.props.textCode)}</h3>
			<h3>{t("Please try again")}</h3>
			<div className="buttons-view-w-t">
				<ul>
					<li>
						<div className="separator-box-buttons-m">
							<button
								className="button-view-normal-m trans-m"
								onClick={this.registerPopupForDms()}
							>
								{t("Ok")}
							</button>
						</div>
					</li>
				</ul>
			</div>
		</div>
	);
}
